import React, { useState } from "react";

import KidsLogo from "./assets/kids-logo.png";
import TeenagersLogo from "./assets/teenagers-logo.png";
import TeenagersImage from "./assets/teenagers-image.png";
import KidsImage from "./assets/kids-image.png";

import Button from "../button";
import PreviewPopup from "../ui/preview-popup";
import { translate } from "react-polyglot";
import useMediaQuery from "../../../../hooks/useMediaQuery";


import "./styles.less";

const BlockCategories = ({ t }) => {
  const [popup, setIsPopupOpened] = useState({ isPopupOpened: false, type: "" });
  const isMobileWidth = useMediaQuery("(max-width: 768px)");

  const handleClosePopup = () => {
    setIsPopupOpened({ isPopupOpened: false, type: "" });
  };

  const handleOpenPopupByType = type => {
    setIsPopupOpened({ isPopupOpened: true, type });
  };

  return (
    <div className="block-categories__container">
      {popup.isPopupOpened && <PreviewPopup type={popup.type} closePopup={handleClosePopup} />}
      <div className="block-categories__cards">
        <div
          onClick={() => handleOpenPopupByType("kids")}
          className="block-categories__card block-categories__card-kids"
        >
          <img className="block-categories__card-logo" width={177} height={85} src={KidsLogo} alt="kids BIGI logo" />
          <p className="block-categories__card-description">{t("landing.block-categories.kids.title")}</p>
          <p className="block-categories__card-text">
            {t("landing.block-categories.kids.description")}
          </p>
          <img className="block-categories__card-img" src={KidsImage} />

          <div className="block-categories__card-button">
            <Button
              size="md"
              text={t("landing.block-categories.kids.button")}
              isIcon={false}
              variant={isMobileWidth ? "default" : "filled"}
            />
          </div>
        </div>

        <div
          onClick={() => handleOpenPopupByType("teenagers")}
          className="block-categories__card block-categories__card-teenagers"
        >
          <img
            className="block-categories__card-logo"
            width={226}
            height={86}
            src={TeenagersLogo}
            alt="teenagers BIGI logo"
          />
          <p className="block-categories__card-description">{t("landing.block-categories.teenagers.title")}</p>
          <p className="block-categories__card-text">{t("landing.block-categories.teenagers.description")}</p>
          <img className="block-categories__card-img" src={TeenagersImage} />
          <div className="block-categories__card-button">
            <Button
              size="md"
              text={t("landing.block-categories.teenagers.button")}
              isIcon={false}
              variant={isMobileWidth ? "default" : "filled"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default translate()(BlockCategories);



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-categories/index.js